import { removePunctuationSigns } from "helpers/objPropsToLowercaseMapper"
import React, { useEffect, useState } from "react"
import { ReactTabulator } from "react-tabulator"
import { currencyFormatter } from "utils/formatters"
import { getSelectHtmlFilterValues } from "utils/tabulatorFilter"

const AlternativeRatingsGrid = ({
  data,
  setData,
  dropdownSelection,
  objectives,
  alternativeName,
  objectivesAndMeasures,
}) => {
  const [columns, setColumns] = useState([])

  useEffect(() => {
    if (dropdownSelection != null) {
      loadColumns()
    }
  }, [dropdownSelection])

  const loadColumns = () => {
    const columns = [
      { field: "alternativenum", title: "ID", width: 80 },
      {
        field: "alternative",
        title: "Name",
        width: 250,
        headerFilter: "input",
      },
      {
        field: "version",
        title: "Version",
        width: 100,
        formatter: function (cell, formatterParams, onRendered) {
          return cell.getValue()
        },
        headerFilter: "select",
        headerFilterFunc: "in",
        headerFilterParams: {
          values: getSelectHtmlFilterValues(
            new Set(
              data
                .map(u => u["version"])
                .filter(x => x !== undefined && x !== null && x !== "")
            )
          ),
          multiselect: true,
        },
      },
    ]

    if (dropdownSelection.value == 0) {
      objectives.forEach(o => {
        columns.push({
          field: removePunctuationSigns(o.objectiveName?.toLowerCase()),
          title: o.objectiveName,
          width: 200,
          formatter: function (cell, formatterParams, onRendered) {
            return cell.getValue()
          },
          headerFilter: "select",
          headerFilterFunc: "in",
          headerFilterParams: {
            values: getSelectHtmlFilterValues(
              new Set(
                data
                  .map(u => u[o.objectiveName?.toLowerCase()])
                  .filter(x => x !== undefined && x !== null && x !== "")
              )
            ),
            multiselect: true,
          },
        })
      })
    } else if (dropdownSelection.value == -99) {
      objectivesAndMeasures.forEach(o => {
        if (o.measureID != undefined) {
          columns.push({
            field: removePunctuationSigns(o.measureName?.toLowerCase()),
            title: o.measureName,
            width: 200,
            formatter: function (cell, formatterParams, onRendered) {
              return cell.getValue()
            },
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: {
              values: getSelectHtmlFilterValues(
                new Set(
                  data
                    .map(u => u[o.measureName?.toLowerCase()])
                    .filter(x => x !== undefined && x !== null && x !== "")
                )
              ),
              multiselect: true,
            },
          })
        } else {
          columns.push({
            field: removePunctuationSigns(o.objectiveName?.toLowerCase()),
            title: o.objectiveName,
            width: 200,
            formatter: function (cell, formatterParams, onRendered) {
              return cell.getValue()
            },
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: {
              values: getSelectHtmlFilterValues(
                new Set(
                  data
                    .map(u => u[o.objectiveName?.toLowerCase()])
                    .filter(x => x !== undefined && x !== null && x !== "")
                )
              ),
              multiselect: true,
            },
          })
        }
      })
    } else {
      objectivesAndMeasures.forEach(m => {
        if (
          m.measureID != undefined &&
          m.objectiveID == dropdownSelection.value
        ) {
          columns.push({
            field: removePunctuationSigns(m.measureName?.toLowerCase()),
            title: m.measureName,
            width: 200,
            formatter: function (cell, formatterParams, onRendered) {
              return cell.getValue()
            },
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: {
              values: getSelectHtmlFilterValues(
                new Set(
                  data
                    .map(u => u[m.measureName?.toLowerCase()])
                    .filter(x => x !== undefined && x !== null && x !== "")
                )
              ),
              multiselect: true,
            },
          })
        }
      })
    }

    columns.push({
      field: "saascore",
      title: "Benefit Score",
      width: 200,
      formatter: function (cell, formatterParams, onRendered) {
        return cell.getValue()
      },
      headerFilter: "select",
      headerFilterFunc: "in",
      headerFilterParams: {
        values: getSelectHtmlFilterValues(
          new Set(
            data
              .map(u => u["saascore"])
              .filter(x => x !== undefined && x !== null && x !== "")
          )
        ),
        multiselect: true,
      },
    })
    columns.push({
      field: "xcost",
      title: "Total Cost",
      width: 200,
      hozAlign: "end",
      formatter: function (cell, formatterParams, onRendered) {
        return currencyFormatter.format(cell.getValue())
      },
    })
    columns.push({
      field: "xcost_project",
      title: "Project Cost",
      width: 200,
      hozAlign: "end",
      formatter: function (cell, formatterParams, onRendered) {
        return currencyFormatter.format(cell.getValue())
      },
    })
    columns.push({
      field: "saarating",
      title: "Group Rating",
      width: 200,
      formatter: function (cell, formatterParams, onRendered) {
        return cell.getValue()
      },
      headerFilter: "select",
      headerFilterFunc: "in",
      headerFilterParams: {
        values: getSelectHtmlFilterValues(
          new Set(
            data
              .map(u => u["saarating"])
              .filter(x => x !== undefined && x !== null && x !== "")
          )
        ),
        multiselect: true,
      },
    })
    columns.push({
      field: "saascorenormal",
      title: "Normalized Score",
      width: 200,
      formatter: function (cell, formatterParams, onRendered) {
        return parseFloat(cell.getValue()).toFixed(2)
      },
    })
    columns.push({
      field: "costbenefit",
      title: "Benefit / Cost Ratio",
      width: 200,
      formatter: function (cell, formatterParams, onRendered) {
        return parseFloat(cell.getValue()).toFixed(3)
      },
    })

    setColumns(columns)
  }

  return (
    <React.Fragment>
      <div
        style={{
          height: "65vh",
          marginBotton: "0px",
          overflowY: "auto",
          overflowX: "auto",
        }}
      >
        {columns.length > 0 && data.length > 0 && (
          <ReactTabulator
            columns={columns}
            data={data}
            options={{
              movableRows: false,
              layout: "fitColumns",
              cssClass: "table-borderless",
            }}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default AlternativeRatingsGrid
